import { DOCUMENT, NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

import { AppService } from '@services/app.services';
import { StepperService } from '@services/stepper.service';

import { BasicObject } from '@interfaces/checkout.interface';
import { Mock, StepMock } from '@interfaces/mock.interface';

import { DataCyDirective } from '../../common/directives/data-cy.directive';
import { Step } from '../../shared/stepper/steps/step';

// @dynamic
@Component({
    selector: 'checkout-mockups-configurator',
    templateUrl: './mockups-configurator.component.html',
    styleUrl: 'mockups-configurator.component.scss',
    standalone: true,
    imports: [DataCyDirective, NgClass],
})
export class MockupsConfiguratorComponent implements OnInit {
    public multiMockModes: BasicObject = {};
    public useMock: boolean = false;
    public mockLabel: string = 'Activer';
    public mockedKey: any = {};
    public steps: Step[] = [];
    public emptyMock: Mock = {
        key: '',
        label: 'Pas de mock',
        data: null,
    };
    public className: string = 'has-border-warning';

    constructor(
        private stepperService: StepperService,
        public appService: AppService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    public ngOnInit(): void {
        this.steps = this.stepperService.steps;
        this.steps.forEach((step: Step) => {
            if (step.stepMocks) {
                step.stepMocks.forEach((stepMock: StepMock) => {
                    if (stepMock) {
                        this.multiMockModes[stepMock.url] = false;
                        const defaultMock: Mock = stepMock.mocks.find((mock: Mock) => mock.default);
                        if (defaultMock) {
                            this.mockedKey[stepMock.url] = defaultMock.key;
                            this.appService.setMocks(stepMock.url, defaultMock);
                        } else {
                            this.mockedKey[stepMock.url] = this.emptyMock.key;
                        }
                    }
                });
            }
        });
        this.useMock = this.appService.debugMode.mocks;
        this.checkUseMock();
        this.appService.debugSubject.subscribe((debugMode) => (this.useMock = debugMode.mocks));
    }

    public mockData(url: string, mock: Mock): void {
        this.mockedKey[url] = mock.key;
        this.appService.setMocks(url, mock, this.multiMockModes[url]);
    }

    public toggleMultiMockMode(url: string): void {
        this.multiMockModes[url] = !this.multiMockModes[url];
    }

    public toggleMock(): void {
        this.useMock = !this.useMock;
        this.appService.setMocksStatus(this.useMock);
        this.checkUseMock();
    }

    protected checkUseMock(): void {
        this.mockLabel = this.useMock ? 'Désactiver' : 'Activer';
        const contentClasses = this.document.getElementById('checkout').classList;
        if (this.useMock) {
            contentClasses.add(this.className);
        } else {
            contentClasses.remove(this.className);
        }
    }
}
